import ChillDude from 'assets/brand/chill.png';
import Clock from 'assets/brand/clock.png';
import Cup from 'assets/brand/cup.png';
import Register from 'assets/brand/register.png';

import { BorderedBox, LargeEmptyState } from '../../../LargeGraphEmptyState';
import locales from './locales';

export const TransactionsEmptyState = () => {
  return (
    <LargeEmptyState
      description={locales.transactions.description}
      gap="space-16"
      headingProps={{
        fontFamily: 'mabry',
        fontSize: 'font-18',
      }}
      image={Register}
      title={locales.transactions.title}
    />
  );
};

export const TeamEmptyState = () => {
  return (
    <LargeEmptyState
      description={locales.team.description}
      gap="space-16"
      headingProps={{
        fontFamily: 'mabry',
        fontSize: 'font-18',
      }}
      image={ChillDude}
      title={locales.team.title}
    />
  );
};

export const ClientEmptyState = () => {
  return (
    <LargeEmptyState
      description={locales.client.description}
      gap="space-16"
      headingProps={{
        fontFamily: 'mabry',
        fontSize: 'font-18',
      }}
      image={ChillDude}
      title={locales.client.title}
    />
  );
};

export const GraphEmptyState = ({
  ...props
}: React.ComponentProps<typeof BorderedBox>) => {
  return (
    <LargeEmptyState
      description={locales.graph.description}
      gap="space-16"
      headingProps={{
        fontFamily: 'mabry',
        fontSize: 'font-18',
      }}
      image={Cup}
      title={locales.graph.title}
      {...props}
    />
  );
};

export const UnavailableDateEmptyState = ({
  ...props
}: React.ComponentProps<typeof BorderedBox>) => {
  return (
    <LargeEmptyState
      description={locales.unavailableDate.description}
      gap="space-16"
      headingProps={{
        fontFamily: 'mabry',
        fontSize: 'font-18',
      }}
      image={Clock}
      title={locales.unavailableDate.title}
      {...props}
    />
  );
};
